export default "__VITE_ASSET__Ci1BFzP0__"